import { Box, Card, CardContent, Stack } from "@mui/material"
import { BoundAutocomplete, BoundTextField } from "lib/@components/binding/bound-components"
import { If } from "lib/@components/switch"
import { useDemand } from "lib/authorization/use-demand"
import { useSkills } from "routes/@lib/skills"

export function AccountDetails() {
    const [skills] = useSkills()
    const isNotShareLinkUser = useDemand("!sharing")

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Card sx={{ minHeight: "350px" }}>
                <CardContent>
                    <Stack spacing={3}>
                        <Stack spacing={3} direction="row" alignItems="center">
                            <BoundTextField field="UserName" id="editAccountEmailAddress" disabled />
                        </Stack>
                        <BoundTextField
                            field="displayName"
                            label="Name"
                            id="editAccountName"
                            data-cy="account-name"
                            yup="string.trim.required"
                            transformOutOnBlur={(name) => name?.trim()}
                        />
                        <If value={isNotShareLinkUser}>
                            <BoundTextField field="jobTitle" id="editAccountPosition" data-cy="account-job-title" />
                            <BoundAutocomplete
                                data-cy="edit-account-skills"
                                default={[]}
                                multiple
                                field="skills"
                                filterSelectedOptions
                                options={Object.keys(skills).sortBy((c) => skills[c]?.Skilling)}
                                getOptionLabel={(o) => `${skills[o]?.Skilling} [${skills[o]?.SkillingCode}]`}
                            />
                        </If>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    )
}
